// user
export const SET_USER_MESSAGE_LIST = 'SET_USER_MESSAGE_LIST'
export const SET_USER_MESSAGE_LIST_PAGE = 'SET_USER_MESSAGE_LIST_PAGE'
export const SET_USER_MESSAGE_LIST_PAGE_TOTAL = 'SET_USER_MESSAGE_LIST_PAGE_TOTAL'
export const SET_DISTRIBUTE_DIALOG = 'SET_DISTRIBUTE_DIALOG'
export const SET_USER_INFO = 'SET_USER_INFO'
export const SET_USER_HARDWARE = 'SET_USER_HARDWARE'
export const SET_MOUNT_PATH_DIALOG = 'SET_MOUNT_PATH_DIALOG'
export const SET_SAFE_LIST = 'SET_SAFE_LIST'
export const SET_USER_MESSAGE_LIST_PAGE_SIZE = 'SET_USER_MESSAGE_LIST_PAGE_SIZE'
export const SET_USER_ZONE = 'SET_USER_ZONE'
export const SET_PLATFORM_USER_MESSAGE = 'SET_PLATFORM_USER_MESSAGE'
export const SET_AGENCY_CHOISE = 'SET_AGENCY_CHOISE'
export const SET_USER_MESSAGE_LIST_SORT = 'SET_USER_MESSAGE_LIST_SORT'
export const SET_QUERY = 'SET_QUERY'
export const CHAHE_USER_MESSAGE_LIST_QUERY = 'CHAHE_USER_MESSAGE_LIST_QUERY'
export const SET_USER_MESSAGE_LIST_SEARCHING = 'SET_USER_MESSAGE_LIST_SEARCHING'
export const SET_USER_ACCOUNT_TYPE = 'SET_USER_ACCOUNT_TYPE'
export const RESET_USER_LIST_QUERY = 'RESET_USER_LIST_QUERY'
export const SET_USER_CONTACT_INFO = 'SET_USER_CONTACT_INFO'
export const SET_USER_PERMISSION = 'SET_USER_PERMISSION'
export const SET_JSON_LIST_LOADING = 'SET_JSON_LIST_LOADING'
export const SET_JSON_CUSTOM_MADE_LIST = 'SET_JSON_CUSTOM_MADE_LIST'

// userRecharge
export const SET_USER_RECHARGE_QUERY = 'SET_USER_RECHARGE_QUERY'
export const INIT_USER_RECHARGE_QUERY = 'INIT_USER_RECHARGE_QUERY'
export const SET_USER_RECHARGE_SEARCHING = 'SET_USER_RECHARGE_SEARCHING'
export const SET_USER_RECHARGE_EXPORTING = 'SET_USER_RECHARGE_EXPORTING'
export const SET_AGENCY_LIST = 'SET_AGENCY_LIST'

// professionalRenderingUpdateRecord
export const SET_RENDERING_UPDATE_RECORD_LIST = 'SET_RENDERING_UPDATE_RECORD_LIST'
export const SET_RENDERING_UPDATE_RECORD_LIST_PAGE = 'SET_RENDERING_UPDATE_RECORD_LIST_PAGE'
export const SET_RENDERING_UPDATE_RECORD_LIST_PAGE_SIZE = 'SET_RENDERING_UPDATE_RECORD_LIST_PAGE_SIZE'
export const SET_RENDERING_UPDATE_RECORD_LIST_PAGE_TOTAL = 'SET_RENDERING_UPDATE_RECORD_LIST_PAGE_TOTAL'
export const SET_RENDERING_UPDATE_RECORD_LIST_QUERY = 'SET_RENDERING_UPDATE_RECORD_LIST_QUERY'
export const SET_RENDERING_UPDATE_RECORD_LIST_SEARCHING = 'SET_RENDERING_UPDATE_RECORD_LIST_SEARCHING'
export const SET_RENDERING_UPDATE_RECORD_LIST_EXPORTINGRECORD = 'SET_RENDERING_UPDATE_RECORD_LIST_EXPORTINGRECORD'

// agentsApplication
export const SET_AGENTS_LIST = 'SET_AGENTS_LIST'
export const SET_AGENTS_LIST_PAGE = 'SET_AGENTS_LIST_PAGE'
export const SET_AGENTS_LIST_PAGE_SIZE = 'SET_AGENTS_LIST_PAGE_SIZE'
export const SET_AGENTS_LIST_PAGE_SIZE_TOTAL = 'SET_AGENTS_LIST_PAGE_SIZE_TOTAL'
export const SET_AGENTS_LIST_QUERY = 'SET_AGENTS_LIST_QUERY'
export const SET_AGENTS_LIST_SEARCHING = 'SET_AGENTS_LIST_SEARCHING'
export const SET_VERIFY_QUERY = 'SET_VERIFY_QUERY'

// userMessageBoard
export const SET_USER_MESSAGES_LIST = 'SET_USER_MESSAGES_LIST'
export const SET_USER_MESSAGES_LIST_PAGE = 'SET_USER_MESSAGES_LIST_PAGE'
export const SET_USER_MESSAGES_LIST_PAGE_SIZE = 'SET_USER_MESSAGES_LIST_PAGE_SIZE'
export const SET_USER_MESSAGES_LIST_PAGE_SIZE_TOTAL = 'SET_USER_MESSAGES_LIST_PAGE_SIZE_TOTAL'
export const SET_USER_MESSAGES_LIST_QUERY = 'SET_USER_MESSAGES_LIST_QUERY'
export const SET_USER_MESSAGE_STATUS = 'SET_USER_MESSAGE_STATUS'

// studentCertification
export const SET_STUDENT_CERTIFICATION_LIST = 'SET_STUDENT_CERTIFICATION_LIST'
export const SET_STUDENT_CERTIFICATION_LIST_PAGE = 'SET_STUDENT_CERTIFICATION_LIST_PAGE'
export const SET_STUDENT_CERTIFICATION_LIST_PAGE_SIZE = 'SET_STUDENT_CERTIFICATION_LIST_PAGE_SIZE'
export const SET_STUDENT_CERTIFICATION_LIST_PAGE_SIZE_TOTAL = 'SET_STUDENT_CERTIFICATION_LIST_PAGE_SIZE_TOTAL'
export const SET_STUDENT_CERTIFICATION_QUERY = 'SET_STUDENT_CERTIFICATION_QUERY'
export const SET_STUDENT_CERTIFICATION_STATUS = 'SET_STUDENT_CERTIFICATION_STATUS'
export const SET_STUDENT_CERTIFICATION_REMARKS = 'SET_STUDENT_CERTIFICATION_REMARKS'
export const SET_STUDENT_CERTIFICATION_IMAGE = 'SET_STUDENT_CERTIFICATION_IMAGE'
export const SET_STUDENT_CERTIFICATION_SEARCHING = 'SET_STUDENT_CERTIFICATION_SEARCHING'

// enterpriseCertification
export const SET_ENTERPRISE_CERTIFICATION_LIST = 'SET_ENTERPRISE_CERTIFICATION_LIST'
export const SET_ENTERPRISE_CERTIFICATION_LIST_PAGE = 'SET_ENTERPRISE_CERTIFICATION_LIST_PAGE'
export const SET_ENTERPRISE_CERTIFICATION_LIST_PAGE_SIZE = 'SET_ENTERPRISE_CERTIFICATION_LIST_PAGE_SIZE'
export const SET_ENTERPRISE_CERTIFICATION_LIST_PAGE_SIZE_TOTAL = 'SET_ENTERPRISE_CERTIFICATION_LIST_PAGE_SIZE_TOTAL'
export const SET_ENTERPRISE_CERTIFICATION_QUERY = 'SET_ENTERPRISE_CERTIFICATION_QUERY'
export const SET_ENTERPRISE_CERTIFICATION_STATUS = 'SET_ENTERPRISE_CERTIFICATION_STATUS'
export const SET_ENTERPRISE_CERTIFICATION_REMARKS = 'SET_ENTERPRISE_CERTIFICATION_REMARKS'
export const SET_ENTERPRISE_CERTIFICATION_IMAGE = 'SET_ENTERPRISE_CERTIFICATION_IMAGE'
export const SET_ENTERPRISE_CERTIFICATION_SEARCHING = 'SET_ENTERPRISE_CERTIFICATION_SEARCHING'

// wechat msg
export const SET_WXCHAT_MSG_LIST = 'SET_WXCHAT_MSG_LIST'
export const SET_WXCHAT_PAGE_TOTAL = 'SET_WXCHAT_PAGE_TOTAL'
export const SET_WXCHAT_PAGE_NUM = 'SET_WXCHAT_PAGE_NUM'

// copyrightRegistration
export const SET_REGISTRATION_LIST = 'SET_REGISTRATION_LIST'
export const SET_REGISTRATION_LIST_PAGE = 'SET_REGISTRATION_LIST_PAGE'
export const SET_REGISTRATION_LIST_PAGE_SIZE = 'SET_REGISTRATION_LIST_PAGE_SIZE'
export const SET_REGISTRATION_LIST_PAGE_SIZE_TOTAL = 'SET_REGISTRATION_LIST_PAGE_SIZE_TOTAL'
export const SET_REGISTRATION_LIST_QUERY = 'SET_REGISTRATION_LIST_QUERY'
export const SET_REGISTRATION_LIST_SEARCHING = 'SET_REGISTRATION_LIST_SEARCHING'
export const SET_REGISTRATION_TABLELIST_QUERY = 'SET_REGISTRATION_TABLELIST_QUERY'
export const SET_REGISTRATIONE_EXPORTIN = 'SET_REGISTRATIONE_EXPORTIN'

// userConsumerBill
export const INIT_SEARCH_DATA = 'INIT_SEARCH_DATA'
export const SET_SALES_MAN_LIST = 'SET_SALES_MAN_LIST'
export const SET_ACTIVE_TAB = 'SET_ACTIVE_TAB'
export const SET_SEARCH_DATA = 'SET_SEARCH_DATA'
export const SET_FEE_TYPE = 'SET_FEE_TYPE'

// pictureClientFeedback
export const SET_PICTURE_CLIENT_FB_QUERY = 'SET_PICTURE_CLIENT_FB_QUERY'
export const SET_PICTURE_CLIENT_FB_SEARCHING = 'SET_PICTURE_CLIENT_FB_SEARCHING'
export const SET_PICTURE_CLIENT_FB_LIST = 'SET_PICTURE_CLIENT_FB_LIST'
export const SET_PICTURE_CLIENT_FB_PAGE_NUM = 'SET_PICTURE_CLIENT_FB_PAGE_NUM'
export const SET_PICTURE_CLIENT_FB_PAGE_SIZE = 'SET_PICTURE_CLIENT_FB_PAGE_SIZE'
export const SET_PICTURE_CLIENT_FB_PAGE_SIZE_TOTAL = 'SET_PICTURE_CLIENT_FB_PAGE_SIZE_TOTAL'

// animationClientFeedback
export const SET_ANIMATION_CLIENT_FB_QUERY = 'SET_PICTURE_CLIENT_FB_QUERY'
export const SET_ANIMATION_CLIENT_FB_SEARCHING = 'SET_PICTURE_CLIENT_FB_SEARCHING'
export const SET_ANIMATION_CLIENT_FB_LIST = 'SET_PICTURE_CLIENT_FB_LIST'
export const SET_ANIMATION_CLIENT_FB_PAGE_NUM = 'SET_PICTURE_CLIENT_FB_PAGE_NUM'
export const SET_ANIMATION_CLIENT_FB_PAGE_SIZE = 'SET_PICTURE_CLIENT_FB_PAGE_SIZE'
export const SET_ANIMATION_CLIENT_FB_PAGE_SIZE_TOTAL = 'SET_PICTURE_CLIENT_FB_PAGE_SIZE_TOTAL'

// userDuplicationCheck
export const SET_DUPLICATION_CHECK_LIST = 'SET_DUPLICATION_CHECK_LIST'
export const SET_DUPLICATION_CHECK_PAGE_NUM = 'SET_DUPLICATION_CHECK_PAGE_NUM'
export const SET_DUPLICATION_CHECK_PAGE_SIZE = 'SET_DUPLICATION_CHECK_PAGE_SIZE'
export const SET_DUPLICATION_CHECK_PAGE_SIZE_TOTAL = 'SET_DUPLICATION_CHECK_PAGE_SIZE_TOTAL'
export const SET_DUPLICATION_CHECK_QUERY = 'SET_DUPLICATION_CHECK_QUERY'
export const SET_DUPLICATION_CHECK_SEARCHING = 'SET_DUPLICATION_CHECK_SEARCHING'

// Batch assignment of salespersons
export const SET_ASSIGN_SALESPERSONS_DATA_LIST = 'SET_ASSIGN_SALESPERSONS_DATA_LIST'
export const SET_ASSIGN_SALESPERSONS_DATA_LIST_QUERY = 'SET_ASSIGN_SALESPERSONS_DATA_LIST_QUERY'
export const SET_ASSIGN_SALESPERSONS_DATA_LIST_SEARCHING = 'SET_ASSIGN_SALESPERSONS_DATA_LIST_SEARCHING'
export const SET_ASSIGN_SALESPERSONS_DATA_LIST_PAGE_TOTAL = 'SET_ASSIGN_SALESPERSONS_DATA_LIST_PAGE_TOTAL'
export const SET_ASSIGN_SALESPERSONS_DATA_LIST_PAGE_NUM = 'SET_ASSIGN_SALESPERSONS_DATA_LIST_PAGE_NUM'
export const SET_ASSIGN_SALESPERSONS_DATA_LIST_PAGE_SIZE = 'SET_ASSIGN_SALESPERSONS_DATA_LIST_PAGE_SIZE'
